import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Paper,
  Grid,
  CardMedia,
  Typography,
  Fade,
} from '@material-ui/core';
import { HeartButton } from 'modules2/components';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
// import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
// import ShareIcon from '@material-ui/icons/Share';

import Controls, {RatingCard, Timer} from '../components/Controls';

import radioImg from 'assets/images/radio200x200.jpg';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#252525',
    width: '100%',
    zIndex: 1100,
    position: 'fixed',
    bottom: 120,
    left: 0,
    height: 84,
    borderRadius: 0,
  },
  rootExpand: {
    background: '#343434',
    height: 84,
  },
  rootMax: {
    background: '#252525',
    width: '100%',
    zIndex: 1100,
    position: 'fixed',
    bottom: 185,
    left: 0,
    height: 0,
    borderRadius: 0,
  },
  maxShift: {
    transition: theme.transitions.create('height', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    height: 170,
  },
  swipeBar: {
    width: '100%',
    zIndex: 1100,
    position: 'fixed',
    bottom: 204,
    left: 0,
    borderRadius: 0,
    height: 25,
    background: '#343434',
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  contentExpand: {
    transition: theme.transitions.create('bottom', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    bottom: 355,
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  mediaArt: {
    width: 100,
    height: 100,
    border: '4px solid #FFF',
  },
  mediaThumb: {
    width: 76,
    height: 76,
    objectFit: 'cover',
    border: '4px solid #FFF',
  },
  text: {
    marginLeft: '-1em',
  },
  radioTitle: {
    marginTop: 5,
    fontSize: 16,
    fontWeight: 'bold',
    color: '#FFF',
    width: 210,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  radioSubtitle: {
    width: 210,
    fontSize: 12,
    color: '#CECECE',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    textTransform: 'capitalize',
  },
  defaultImageTitle: {
    top: 15,
    width: 100,
    fontSize: 13,
    color: '#fff',
    padding: '0 5px',
    position: 'absolute',
    display: 'block',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  defaultTitle: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  },
}));

const MiniPlaybar = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const {
    player,
    statevolum,
    handleVolume,
    audioStatus,
    toggleAudio,
    title,
    image,
    heartedStationIds,
  } = props;

  const [expanded, setExpanded] = React.useState(false);
  // const [defaultImage, setDefaultImage] = useState(false);
  const isHearted = heartedStationIds
      ? heartedStationIds.some(
          (stationId) => stationId === props.station.stationuuid
      )
      : false;
  const expandPlayer = () => setExpanded(!expanded);

  const onMediaFallback = (event) => {
    event.target.src = radioImg;
    // setDefaultImage(true);
  };

  const onFavouriteClickHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();
    props.onFavouriteClick(props.station.stationuuid);
  };

  const style = {
    height: 25,
    width: 25,
    fill: theme.palette.pink,
  };

  const returnMaximizedPlayer = () => {
    if (expanded) {
      return (
        <Grid
          container
          direction="column"
          className="main-player-inner"
          justify="center"
          alignItems="center"
          style={{ marginTop: theme.spacing(1) }}
        >
          {/*<Grid item>
            <CardMedia
              className={classes.mediaArt}
              alt="Image not available"
              component="img"
              src={image}
              onError={onMediaFallback}
            />
            {defaultImage && (
                <div
                    className={clsx(
                        'defaultImageTitle',
                        classes.defaultImageTitle
                    )}
                >
                  <Grid className={classes.defaultTitle}>{title}</Grid>
                </div>
            )}
          </Grid>*/}

          <Grid item style={{textAlign: 'center'}}>
            <Typography className={classes.radioTitle}>{title}</Typography>
            <Typography className={classes.radioSubtitle}>
              {audioStatus}&nbsp;
              {props.state || props.country ? '|' : ''}&nbsp;
              {props.state ? props.state + ', ' : ''}&nbsp;
              {props.country}
            </Typography>
            {/*<Typography className={classes.radioSubtitle}>
              {subtitle}
            </Typography>*/}
          </Grid>

          <Grid item>
            <Controls
              mini
              statevolum={statevolum}
              handleVolume={handleVolume}
              toggleAudio={toggleAudio}
              expanded
              status={audioStatus}
              player={player}
            />
          </Grid>
          <Timer currentTime={props.currentTime}/>
        </Grid>
      );
    }
  };

  const returnMinimizedPlayer = () => {
    if (expanded) {
      return (
        <Fade in={expanded}>
          <Grid container spacing={0} justify="center" alignItems="center">
            <Grid item xs={4}>
              <CardMedia
                  className={classes.mediaThumb}
                  alt="Image not available"
                  component="img"
                  src={image}
                  onError={onMediaFallback}
              />
            </Grid>
            <Grid item xs={6}>
              {/*<VolumeSlider
                statevolum={statevolum}
                handleVolume={handleVolume}
              />*/}
              <RatingCard
                  stationid={props.stationid}
                  isFiveStar={props.isFiveStar}
                  onRatingHandle={props.onRatingHandle}
              />
            </Grid>
            <Grid item xs={2}>
              <HeartButton
                  style={style}
                  isHearted={isHearted}
                  onFavouriteClickHandler={onFavouriteClickHandler}
              />
            </Grid>
            {/*<Grid item xs={2}>
              <IconButton aria-label="share">
                <ShareIcon />
              </IconButton>
            </Grid>*/}
          </Grid>
        </Fade>
      );
    }

    return (
      <Grid container direction="row">
        <Grid item xs={10} sm={10} md={10}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <CardMedia
                className={classes.mediaThumb}
                alt="Image not available"
                component="img"
                src={image}
                onError={onMediaFallback}
              />
              {/*{defaultImage && (
                  <div
                      className={clsx(
                          'defaultImageTitle',
                          classes.defaultImageTitle
                      )}
                  >
                    <Grid className={classes.defaultTitle}>{title}</Grid>
                  </div>
              )}*/}
            </Grid>
            <Grid item xs={8} className={classes.text}>
              <Typography className={classes.radioTitle}>{title}</Typography>
              <Typography className={classes.radioSubtitle}>
                {audioStatus}&nbsp;
                {props.state || props.country ? '|' : ''}&nbsp;
                {props.state ? props.state + ', ' : ''}&nbsp;
                {props.country}
              </Typography>
              <Timer currentTime={props.currentTime}/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item className={classes.player} xs={2} sm={2} md={2}>
          <Controls
            mini
            statevolum={statevolum}
            handleVolume={handleVolume}
            toggleAudio={toggleAudio}
            status={audioStatus}
            player={player}
          />
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Paper
        className={clsx(classes.swipeBar, {
          [classes.contentExpand]: expanded,
        })}
      >
        <Grid
          container
          justify="center"
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          style={{ pointer: 'cursor' }}
          onClick={expandPlayer}
        >
          <ExpandLessIcon style={{ color: 'white' }} />
        </Grid>
      </Paper>

      <Paper
        className={clsx(classes.rootMax, {
          [classes.maxShift]: expanded,
        })}
      >
        {returnMaximizedPlayer()}
      </Paper>

      <Paper
        className={clsx(classes.root, {
          [classes.rootExpand]: expanded,
        })}
      >
        {returnMinimizedPlayer()}
      </Paper>
    </>
  );
};

export default MiniPlaybar;
